module.exports = __webpack_public_path__ + "assets/img/27_1523_big.ab9b0b80.jpg";